import { createElementVNode as _createElementVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "bg-gray-100 false flex flex-col h-64 items-center justify-center max-w-full min-w-full sm:max-w-64 sm:min-w-64 px-3 py-3 rounded-md shadow w-full" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("p", null, " อัพโหลดสลิป ", -1)
const _hoisted_3 = [
  _hoisted_2
]
const _hoisted_4 = {
  key: 1,
  class: "min-w-52 max-w-52 h-52 rounded-md py-2 px-2 flex items-center justify-center gap-4 bg-transparent cursor-move shadow bg-white relative"
}
const _hoisted_5 = /*#__PURE__*/_createElementVNode("svg", {
  role: "img",
  "aria-hidden": "true",
  focusable: "false",
  "data-prefix": "fas",
  "data-icon": "times",
  class: "svg-inline--fa fa-times fa-w-11",
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 352 512"
}, [
  /*#__PURE__*/_createElementVNode("path", {
    fill: "currentColor",
    d: "M242.72 256l100.07-100.07c12.28-12.28 12.28-32.19 0-44.48l-22.24-22.24c-12.28-12.28-32.19-12.28-44.48 0L176 189.28 75.93 89.21c-12.28-12.28-32.19-12.28-44.48 0L9.21 111.45c-12.28 12.28-12.28 32.19 0 44.48L109.28 256 9.21 356.07c-12.28 12.28-12.28 32.19 0 44.48l22.24 22.24c12.28 12.28 32.2 12.28 44.48 0L176 322.72l100.07 100.07c12.28 12.28 32.2 12.28 44.48 0l22.24-22.24c12.28-12.28 12.28-32.19 0-44.48L242.72 256z"
  })
], -1)
const _hoisted_6 = [
  _hoisted_5
]
const _hoisted_7 = { class: "flex flex-col justify-center items-center gap-4" }
const _hoisted_8 = ["src"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (!_ctx.selFile)
      ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
          _createElementVNode("div", {
            onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.clickFile && _ctx.clickFile(...args))),
            class: "btn_upload min-w-52 shadow-md cursor-pointer text-center"
          }, _hoisted_3),
          _createElementVNode("input", {
            class: "hidden",
            ref: "file",
            type: "file",
            onChange: _cache[1] || (_cache[1] = ($event: any) => (_ctx.fileBrowseHandler($event.target)))
          }, null, 544)
        ], 64))
      : (_openBlock(), _createElementBlock("div", _hoisted_4, [
          _createElementVNode("div", {
            onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.deleteUrl())),
            class: "absolute top-1 right-2 w-4 text-red-500 cursor-pointer"
          }, _hoisted_6),
          _createElementVNode("div", _hoisted_7, [
            _createElementVNode("img", {
              class: "picUpload",
              src: _ctx.selFile
            }, null, 8, _hoisted_8)
          ])
        ]))
  ]))
}